module.exports = __webpack_public_path__ + "static/media/gb-sct.31ef8bcf.svg";